<template>
    <div>
        <modal class="how-to-set" :display="modalStatus.howToSetTaskTime" @modalStatus="closeModal" >
            <h1>不知道如何設定委託時間？</h1>
            <div class="how-to-set-wrap">
                <ul>
                    <li>1. 希望受託人幫您帶看新租客的期間，最多為兩個月</li>
                    <li>2. 當受託人是房客時，委託結束時間，不可早於租約到期日</li>
                </ul>
                <!-- <div class="content">
                    <div class="list">
                        <span class="title">委託時間是什麼？</span>
                        <span class="info">我是說明文案我是說明文案，我是說明文案，我是說明文案我是說明文案我是說明文案我是說明文我是說明文。</span>
                    </div>
                    <div class="list">
                        <span class="title">我該如何設定委託時間？</span>
                        <span class="info">我是說明文案我是說明文案，我是說明文案，我是說明文案我是說明文案我是說明文案我是說明文案我是說明文案。</span>
                    </div>
                    <div class="list">
                        <span class="title">我設定的委託時間對房客有什麼影響？</span>
                        <span class="info">我是說明文案我是說明文案，我是說明文案，我是說明文案我是說明文案我是說明文案我是說明文案我是說明文案我是說明文案我是說明文案我是說明文案我是說明文案。</span>
                    </div>
                </div> -->
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
        }
    },
    // mounted() {
    //     this.$analytics.logEvent('帳單明細', { screen_name: '帳單明細'})
    // },
    methods: {
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'howToSetTaskTime'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.how-to-set{
        .modal-content{
            width: 448px;
            height: 400px;
            padding: 0 !important;
            .detail{
                align-items: flex-start;
                >h1{
                    width: 320px;
                    text-align: center;
                    font-size: 24px;
                    margin: 32px auto;
                    line-height: 1.5;
                }
                .how-to-set-wrap{
                    padding: 0px 32px;
                    ul{
                        li{
                            line-height: 1.5;
                            margin-bottom: 12px;
                        }
                    }
                    .content{
                        margin-bottom: 20px;
                        .list{
                            margin-bottom: 34px;
                            .title{
                                display: block;
                                font-size: 16px;
                                font-weight: 500;
                                margin-bottom: 12px;
                            }
                        }
                    }
                }
            }
      
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/modal/howToSetTaskTime.vue